import { useMediaQuery } from '@material-ui/core'
import ErrorLine from 'components/ErrorLine'
import Button from 'components/CustomButtons/Button.js'
import NumericInputField from 'components/NumericInputField'
import { getETHRate } from 'eth/ethUtils'
import { getAccountBalanceEth } from 'eth/ethUtils'
import { decodeHarmonizeError } from 'eth/ethUtils'
import { getGasEstimateToSetPrice } from 'eth/ethUtils'
import { getLocalPrice } from 'eth/ethUtils'
import { getDisplayError } from 'eth/tokenUtils'
import { store } from 'index'
import { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateNFT } from 'redux/actions/nftActions'
import { primaryColor } from 'assets/jss/material-kit-react'
import { isVeryNarrow } from 'util/screenUtils'
import TransactionCost from './TransactionCost'
import { getTokenPrice } from 'eth/ethUtils'
export default function SetPrice({ onAction }) {
    const veryNarrow = isVeryNarrow(useMediaQuery)
    const { price, tokenId } = useSelector(state => state.nfts)
    const [gasEstimate, setGasEstimate] = useState()
    const [ethBalance, setEthBalance] = useState()
    const [ethInCurrency, setEthInCurrency] = useState(0)
    const { currency } = useSelector(state => state.settings)
    const [error, setError] = useState()
    const dispatch = useDispatch()

    const displayHarmonizeError = (error) => {
        getDisplayError(error, setError)
    }
    /**
 * @param {*} value
 */
    const updatePrice = (value) => {
        const nft = store.getState().nfts
        dispatch(updateNFT({ ...nft, price: value }))
    }
    const getGasEstimate = async () => {

        try {
            setError('')
            const estimate = await getGasEstimateToSetPrice(tokenId, price)
            setGasEstimate(estimate)
        } catch (error) {
            displayHarmonizeError(decodeHarmonizeError(error))
        }

    }

    const displayMain = () => {
        return (
            <div style={{
                display: 'flex', flexDirection: 'column', justifyContent: 'center',
                border: '1px solid ' + primaryColor,
                margin: '0.5em',
                padding: '1em',
                borderRadius: '0.5em',
                width: '90%',
                boxShadow: '1px 1px 10px 1px grey'
            }}>
                <h4 style={{ textAlign: 'center' }}>
                    Set NFT Price
                </h4>
                <ErrorLine error={error} />
                <div style={{ display: 'flex', alignItems: 'end', justifyContent: 'center' }}>
                    <div style={{ width: veryNarrow ? '100%' : '50%' }}>
                        <NumericInputField
                            helper={price <= 0 ? 'Not for sale' : `NFT Sale Price (\u{039E})`}
                            min={0}
                            max={parseInt(process.env.REACT_APP_MAX_TOKEN_PRICE_ETH)}
                            getter={() => {
                                return price
                            }}
                            step={0.01}
                            setter={updatePrice}
                        />
                    </div>
                    <div>{getLocalPrice(price, ethInCurrency, currency)}</div>
                </div>
                <Button
                    color="success"
                    title='Set NFT price'
                    style={{ cursor: 'pointer' }}
                    onClick={onAction}>
                    Set Price
                </Button>
                <TransactionCost
                    gasEstimate={gasEstimate}
                    action='set price'
                    ethInCurrency={ethInCurrency}
                    ethBalance={ethBalance}
                />
            </div>
        )
    }

    useEffect(() => {
        const getEthBalance = async () => {
            try {
                const balance = await getAccountBalanceEth()
                setEthBalance(balance)
                getETHRate(currency).then(async (rate) => {
                    setEthInCurrency(rate)
                    await getGasEstimate()
                })
                const currentPrice = await getTokenPrice(tokenId)
                updatePrice(currentPrice)
            } catch (error) {
                console.error('getEthBalance failed', error)
                setError(JSON.stringify(error))
            }
        }
        getEthBalance()
    }, [])
    return displayMain()
}